// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__3KclS","divider":"styles_divider__-CA6e","content":"styles_content__l6RqW","red":"styles_red__8fIgf","text_wrapper":"styles_text_wrapper__zuB14"};